import { render } from "./InstructorHome.vue?vue&type=template&id=269625e2"
import script from "./InstructorHome.vue?vue&type=script&lang=js"
export * from "./InstructorHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__